import initiateUnsplashSearchQueryGeneration from './initiate-unsplash-search-query-generation';

const getUnsplashSearchQuery = async () => {
  try {
    const { results } = await initiateUnsplashSearchQueryGeneration();
    return results.searchQuery;
  } catch (e) {
    console.error(e);
    return '';
  }
};

export default getUnsplashSearchQuery;
